import styled from "styled-components";

export const Container = styled.div``;

export const ContentItems = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 8px;
    border-radius: 8px;

    background-color: ${(props) => props.theme.colors.gray.gray_50};
`;

export const DividerGraph = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
`;

export const FrameGraph = styled.div`
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 2px 0px rgb(0,0,0, .25);
    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
`;

export const LabelGraph = styled.p`
    span{
        color: ${(props) => props.theme.colors.primary};
    }
`;